module.exports = __webpack_public_path__ + "img/folder-pink.e67efcbd.svg";